import { Trans } from 'react-i18next'

import vanGoghEarPNG from '~/assets/images/art/van-gogh-ear.png'
import vanGoghEarWEBP from '~/assets/images/art/van-gogh-ear.webp'
import { ImageLayoutStyles as PS } from '~/pages/anatomy/quizBinaryChoice/libs/styles/imageLayout'
import { FactCaption } from '~/pages/art/factCard/libs/caption'
import { FactImageWrapper } from '~/pages/art/factCard/libs/imageWrapper'
import {
  ANSWERS,
  greenAccept,
  redCross,
} from '~/pages/onboarding/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const VAN_GOGH_EAR_QUESTION = `Van Gogh cut off his ear... and gave it to a woman`

const VanGoghEar = ({ nextPagePath, pageId }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: VAN_GOGH_EAR_QUESTION,
  })

  return (
    <PS.Root>
      <PS.StyledContainer>
        <FactImageWrapper>
          <picture>
            <source srcSet={vanGoghEarWEBP} type="image/webp" />
            <img src={vanGoghEarPNG} alt="Van Gogh self-portrait" />
          </picture>
        </FactImageWrapper>

        <FactCaption>
          <Trans ns="art" i18nKey="onboarding.factCard.didYouKnow" />
        </FactCaption>

        <PS.Question>
          <Trans ns="art" i18nKey="onboarding.factCard.vanGoghEar.statement" />
        </PS.Question>

        <PS.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </PS.ButtonWrapper>
      </PS.StyledContainer>
    </PS.Root>
  )
}

export default VanGoghEar
